const generateUniqueID = () => Math.floor(Math.random() * Math.floor(999999999));
export default generateUniqueID;
